import { render, staticRenderFns } from "./ProfilingStart.vue?vue&type=template&id=32855f1c&scoped=true"
import script from "./ProfilingStart.vue?vue&type=script&lang=js"
export * from "./ProfilingStart.vue?vue&type=script&lang=js"
import style0 from "./ProfilingStart.vue?vue&type=style&index=0&id=32855f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32855f1c",
  null
  
)

export default component.exports